module.exports = __webpack_public_path__ + "assets/img/9b39658b836a52f1f4585464a0db42c7.svg";